// When a paginated list comes back empty but the server still reports a total
// and we're past page 1, the current page is out of range (e.g. the last row on
// the final page was just deleted). Step back a page and report that we did, so
// the caller can `return` before rendering a blank list. Returns true if it
// stepped back.
export function clampPageOnEmpty({ results, count, page, setPage }) {
  if (results.length === 0 && count > 0 && page > 1) {
    setPage((p) => Math.max(1, p - 1));
    return true;
  }
  return false;
}
